module.exports = __webpack_public_path__ + "img/orange-gradient-bg.75fc2afe.svg";